import { useEffect, useState } from 'react';
import { Typography } from '../../typography';
import { ModalBase, ModalWrapper } from '../ModalComponents';
import { YardPlaceScene } from '../../yard-place-scene';
import { i18n } from '../../../i18n';

export const yardPlaceSceneViewModal = {
  open: () => {},
  blocksScene: '',
  defaultSelected: '',
};

const resetModal = () => {
  yardPlaceSceneViewModal.blocksScene = '';
  yardPlaceSceneViewModal.defaultSelected = '';
};

export const YardPlaceSceneViewModal = () => {
  const [open, setOpen] = useState(false);

  const [updateKey, setUpdateKey] = useState(Math.random());

  useEffect(() => {
    yardPlaceSceneViewModal.open = () => {
      setOpen(true);
      setUpdateKey(Math.random());
    };
  }, []);

  const handleOnClose = () => {
    resetModal();
    setOpen(false);
  };

  return (
    <ModalBase
      id={'yard-place-scene-view-modal'}
      paperSize={'full-screen'}
      open={open}
      onClose={handleOnClose}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.yardPlaceSceneTitle')}
        </Typography>
        <YardPlaceScene
          key={updateKey}
          defaultValue={yardPlaceSceneViewModal.blocksScene}
          defaultSelected={yardPlaceSceneViewModal.defaultSelected}
          defaultMode="view-containers"
        />
      </ModalWrapper>
    </ModalBase>
  );
};
